const FinancialAmount = ({amount, option}: IFinancialAmountProps) => {
  return (
    <div className=" flex justify-between mt-7">
      <p className=" text-gray-6">مقدار نیاز مالی:</p>
      <p className=" text-gray-6">
        {amount} {option}
      </p>
    </div>
  );
};

export default FinancialAmount;
